import React, { Fragment } from "react";
import { CloudDownload, Print } from "@material-ui/icons";
import { useErrorHandler } from "../../../hooks";
import {
    Button,
    DialogActions,
    DialogContent,
    Divider,
    Grid,
    Paper,
    Table,
    TextField,
    Typography,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Link,
    Dialog,
    CircularProgress,
    MenuItem,
} from "@material-ui/core";
import DialogTitle from "../../../components/dialog-title";
import FormBuilder from "../../../components/form-builder";
import { dateFormat } from "../../../helpers/date-helpers";
import { useMemo } from "react";
import { currencyFormat, phoneFormat } from "../../../helpers";
import { useSelector } from "react-redux";
import { useState } from "react";
import { useEffect } from "react";
import ordersService from "../../../services/orders.service";
import { MOBILE_REG } from "../../../constants/regex";
import useCopyToClipboard from "../../../hooks/useCopyToClipboard";
import InfoOutlined from "@material-ui/icons/InfoOutlined";
import CoordinationFormModal from "../../admin/coordination/form"
import customersService from "../../../services/customers.service";
import appService from "../../../services/app.service";
import printInvoiceDocument from "./print-invoice";
import printWarrantyDocument from "./print-warranty";
import SnappOrderActions from "./snapp-actions";
// import { ImageOutlined as ImageOutlinedIcon } from "@material-ui/icons";
// import { openImage } from "../../../redux/app";
// import { useDispatch } from "react-redux";
// import coordinationService from "../../../services/coordination.service";

function locationTemplate(address, postalCode, location) {
    return (
        `آدرس: ${address}\n` +
        `کد پستی: ${postalCode}\n\n\n` +
        `google: https://www.google.com/maps/search/?api=1&query=${location}\n\n` +
        `waze: https://www.waze.com/ul?ll=${location}\n\n` +
        `apple: https://maps.apple.com/?daddr=${location}`
    );
}

const paymentMethodLabels = {
    inPerson: "حضوری",
    online: "آنلاین",
};

const paymentStatusLabels = {
    awaitingPayment: "در انتظار پرداخت",
    paid: "پرداخت شده",
    failed: "ناموفق",
};

const safeJsonParse = (value, fallback = null) => {
    if (!value) return fallback;
    try {
        return JSON.parse(value);
    } catch (err) {
        return fallback;
    }
};

export default function FormModalContent({ close, data }) {
    const {
        id,
        trackingCode,
        status,
        user,
        createDate,
        deliveryDate,
        description,
        totalAmount,
        payableAmount,
        totalDiscount,
        totalInsurance,
        // TODO: show transaction
    } = data;

    const [showFullImg, setShowFullImg] = useState(null)
    const [info, setInfo] = useState();
    const [downloadingWarrantyItemId, setDownloadingWarrantyItemId] = useState(null);
    const [pendingWarrantyItem, setPendingWarrantyItem] = useState(null);
    const [savingWarrantyUser, setSavingWarrantyUser] = useState(false);
    const [warrantyUserFields, setWarrantyUserFields] = useState({
        gender: "",
        firstNameEnglish: "",
        lastNameEnglish: "",
    });
    const errorHandler = useErrorHandler();
    const { initials } = useSelector((s) => s.app);
    const { account } = useSelector((s) => s.auth);

    const [lensDetail, setLensDetail] = useState(null)

    const initialValues = useMemo(
      () => ({ status, deliveryDate, description }),
      [status, deliveryDate, description]
    );
    const isSnappOrder =
        data?.paymentProvider === "snapp" ||
        info?.transaction?.provider === "snapp";
    const orderStatusOptions = useMemo(() => {
        const options = initials.enums.orderStatus.filter(
            (i) =>
                !["awaitingPayment"].includes(i.value) &&
                !(isSnappOrder && i.value === "cancelled")
        );
        if (!options.some((item) => item.value === "readyForDeliver")) {
            options.push({
                key: "ReadyForDeliver",
                value: "readyForDeliver",
                title: "آماده تحویل",
            });
        }
        return options;
    }, [initials, isSnappOrder]);
    const form = useMemo(
        () => [
            {
                _wrapper: (props) => <Grid item xs={12} sm={6} {...props} />,
                _type: "autocomplete",
                _empty: undefined,
                name: "status",
                options: orderStatusOptions,
                valueSelector: "value",
                labelSelector: "title",
                label: "وضعیت",
                disableClearable: true,
            },
            {
                _wrapper: (props) => <Grid item xs={12} sm={6} {...props} />,
                _type: "datePicker",
                name: "deliveryDate",
                label: "تاریخ ارسال",
                clearable: true,
                time: true,
            },
            {
                _wrapper: (props) => <Grid item xs={12} {...props} />,
                _type: "textField",
                name: "description",
                multiline: true,
                rows: 4,
                label: "توضیحات",
            },
            // { deliveryDate, description },
        ],
        [orderStatusOptions]
    );
    const [phoneNumber, setPhoneNumber] = useState("");
    const [sending, setSending] = useState();
    const copyToClipboard = useCopyToClipboard();

    useEffect(() => {
        if (!account?.phoneNumber) return;
        setPhoneNumber(account.phoneNumber);
    }, [account]);

    useEffect(() => {
        if (!id) return;
        ordersService.getOrder(id).then(({ data, error }) => {
            setInfo(data);
            if (data?.items?.find(it => it.lens)) {
                let lenses = data?.items?.filter(it => it.lens)
            }
        });
    }, [id]);

    const handleSubmit = async (model, { setSubmitting, isSubmitting }) => {
        const { error } = await ordersService.editOrder(id, model);
        setSubmitting(false);
        if (error) return errorHandler(error);
        close(true);
    };

    const validPhoneNumber = useMemo(() => {
        if (!phoneNumber) return;
        return phoneNumber.match(MOBILE_REG);
    }, [phoneNumber]);
    const address = useMemo(() => {
        if (!info || !info?.address) return;
        const { province, city, postalAddress, neighborhood } = info.address;
        return `${province.name}، ${city.name}، ${neighborhood}، ${postalAddress}`;
    }, [info]);

    const sendLocation = async () => {
        if (sending) return;
        setSending(true);
        await ordersService.sendLocation({
            phoneNumber,
            address,
            name: user.fullName,
            location: info?.address?.location ?? "",
            userPhone: user.phoneNumber,
        });
        setSending(false);
    };
    const copyLocation = () => {
        const { location, postalCode } = info.address;
        copyToClipboard(locationTemplate(address, postalCode, location));
    };

    const printInvoice = async () => {
        const latestInitials = await appService.getInitials();
        printInvoiceDocument({
            order: info,
            fallbackOrder: data,
            initials: latestInitials || initials,
        });
    };
    const openLensModal = (id) => {
        const glass = info?.items.find(item => item.id === id);
        if (glass && glass?.userGlassLens?.coordination) {
            setLensDetail(glass);
        }
    }
    const printWarranty = (item, customerOverride) => {
        printWarrantyDocument({
            item,
            order: info,
            fallbackOrder: data,
            customer: customerOverride,
        });
    };
    const downloadWarranty = async (item, customerOverride) => {
        if (downloadingWarrantyItemId !== null) return;

        setDownloadingWarrantyItemId(item.id);
        try {
            printWarranty(item, customerOverride);
        } catch (error) {
            errorHandler(error);
        } finally {
            setDownloadingWarrantyItemId(null);
        }
    };

    const generateAndDownloadWaranry = (item) => {
        const customer = info?.user || user;
        if (
            customer?.gender &&
            customer?.firstNameEnglish &&
            customer?.lastNameEnglish
        ) {
            downloadWarranty(item);
            return;
        }

        setWarrantyUserFields({
            gender: customer?.gender || "",
            firstNameEnglish: customer?.firstNameEnglish || "",
            lastNameEnglish: customer?.lastNameEnglish || "",
        });
        setPendingWarrantyItem(item);
    };

    const closeWarrantyUserModal = () => {
        if (savingWarrantyUser) return;
        setPendingWarrantyItem(null);
    };

    const updateWarrantyUserField = (event) => {
        const { name, value } = event.target;
        setWarrantyUserFields((current) => ({
            ...current,
            [name]: value,
        }));
    };

    const englishNamePattern = /^[A-Za-z][A-Za-z\s'-]*$/;
    const validWarrantyUserFields =
        Boolean(warrantyUserFields.gender) &&
        englishNamePattern.test(warrantyUserFields.firstNameEnglish.trim()) &&
        englishNamePattern.test(warrantyUserFields.lastNameEnglish.trim());

    const saveWarrantyUserAndDownload = async () => {
        if (!validWarrantyUserFields || savingWarrantyUser) return;

        const customer = info?.user || user;
        const item = pendingWarrantyItem;
        const model = {
            gender: warrantyUserFields.gender,
            firstNameEnglish: warrantyUserFields.firstNameEnglish.trim(),
            lastNameEnglish: warrantyUserFields.lastNameEnglish.trim(),
        };

        setSavingWarrantyUser(true);
        const { data: updatedUser, error } = await customersService.editCustomer(
            customer.id,
            model
        );
        setSavingWarrantyUser(false);

        if (error) return errorHandler(error);

        const updatedCustomer = {
            ...(customer || {}),
            ...updatedUser,
            ...model,
        };

        setInfo((current) => ({
            ...current,
            user: {
                ...(current?.user || customer),
                ...updatedCustomer,
            },
        }));
        setPendingWarrantyItem(null);
        await downloadWarranty(item, updatedCustomer);
    };

    const installment = safeJsonParse(data?.installmentForm);
    const answersOfInstallment = safeJsonParse(data?.answersOfInstallment);
    const installmentForm = installment ? safeJsonParse(installment?.form, []) : []

    console.log(info)

    return (
        <>

            {showFullImg &&
                <Dialog
                    open
                    maxWidth={"lg"}
                    fullWidth
                >
                    <DialogTitle onClose={() => setShowFullImg(null)}></DialogTitle>
                    <DialogContent>
                        <img src={showFullImg} />
                    </DialogContent>
                </Dialog>
            }
            <Dialog
                open={Boolean(pendingWarrantyItem)}
                onClose={closeWarrantyUserModal}
                fullWidth
                maxWidth="sm"
            >
                <DialogTitle onClose={closeWarrantyUserModal}>
                    تکمیل اطلاعات گارانتی
                </DialogTitle>
                <DialogContent>
                    <Typography className="mb-3">
                        برای صدور گارانتی، جنسیت و نام و نام خانوادگی انگلیسی مشتری را وارد کنید.
                    </Typography>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <TextField
                                select
                                fullWidth
                                required
                                name="gender"
                                label="جنسیت"
                                value={warrantyUserFields.gender}
                                onChange={updateWarrantyUserField}
                                disabled={savingWarrantyUser}
                            >
                                <MenuItem value="male">مرد</MenuItem>
                                <MenuItem value="female">زن</MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                required
                                name="firstNameEnglish"
                                label="نام انگلیسی"
                                value={warrantyUserFields.firstNameEnglish}
                                onChange={updateWarrantyUserField}
                                error={
                                    Boolean(warrantyUserFields.firstNameEnglish) &&
                                    !englishNamePattern.test(
                                        warrantyUserFields.firstNameEnglish.trim()
                                    )
                                }
                                helperText="فقط حروف انگلیسی وارد شود"
                                inputProps={{ dir: "ltr", maxLength: 31 }}
                                disabled={savingWarrantyUser}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                required
                                name="lastNameEnglish"
                                label="نام خانوادگی انگلیسی"
                                value={warrantyUserFields.lastNameEnglish}
                                onChange={updateWarrantyUserField}
                                error={
                                    Boolean(warrantyUserFields.lastNameEnglish) &&
                                    !englishNamePattern.test(
                                        warrantyUserFields.lastNameEnglish.trim()
                                    )
                                }
                                helperText="فقط حروف انگلیسی وارد شود"
                                inputProps={{ dir: "ltr", maxLength: 31 }}
                                disabled={savingWarrantyUser}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={closeWarrantyUserModal} disabled={savingWarrantyUser}>
                        انصراف
                    </Button>
                    <Button
                        color="primary"
                        variant="contained"
                        onClick={saveWarrantyUserAndDownload}
                        disabled={!validWarrantyUserFields || savingWarrantyUser}
                    >
                        {savingWarrantyUser ? (
                            <CircularProgress size={22} color="inherit" />
                        ) : (
                            "ذخیره و دانلود"
                        )}
                    </Button>
                </DialogActions>
            </Dialog>
            <DialogTitle onClose={() => close()}>سفارش {trackingCode}</DialogTitle>
            <Divider />
            <DialogContent>
                {user && (
                    <Paper className="mt-2 mb-4 p-2" variant="outlined">
                        <Typography component="h3" variant="h6">
                            مشخصات مشتری
                        </Typography>
                        <Divider className="my-2" />
                        <Grid container spacing={2}>
                            <Grid item sm={6}>
                                <Typography component="span">نام: </Typography>
                                <Typography component="span">{user.fullName}</Typography>
                            </Grid>
                            <Grid item sm={6}>
                                <Typography component="span">شماره تماس: </Typography>
                                <Typography component="span" className="en">
                                    {phoneFormat(user.phoneNumber)}
                                </Typography>
                            </Grid>
                            <Grid item sm={6}>
                                <Typography component="span">ایمیل: </Typography>
                                <Typography component="span" className="en">
                                    {user.email}
                                </Typography>
                            </Grid>
                            <Grid item sm={6}>
                                <Typography component="span">تاریخ عضویت: </Typography>
                                <Typography component="span">
                                    {dateFormat(user.createDate)}
                                </Typography>
                            </Grid>
                            <Grid item sm={6}>
                                <Typography component="span">کد ملی: </Typography>
                                <Typography component="span">{user.nationalCode}</Typography>
                            </Grid>

                            {(info && info?.address) && (
                                <>
                                    <Grid item xs={12}>
                                        <Divider className="mb-2" />
                                        <Typography component="span">آدرس: </Typography>
                                        <Typography component="span">{address}</Typography>
                                    </Grid>
                                    
                                    <Grid item sm={6}>
                                        <Typography component="span">کد پستی: </Typography>
                                        <Typography component="span">
                                            {info?.address?.postalCode}
                                        </Typography>
                                    </Grid>
                                    <Grid item sm={6}>
                                        <Typography component="span">موقعیت: </Typography>
                                        <Link
                                            target="_blank"
                                            rel="noreferrer"
                                            href={`https://www.google.com/maps/search/?api=1&query=${info?.address?.location}`}
                                        >
                                            {info?.address?.location}
                                        </Link>
                                    </Grid>
                                    <Grid item sm={6}>
                                        <TextField
                                            value={phoneNumber}
                                            onChange={(e) => setPhoneNumber(e.target.value)}
                                            fullWidth
                                            label="شماره تلفن"
                                            type="phone"
                                            className="code-text-field"
                                        />
                                    </Grid>
                                    <Grid item xs={6} sm={3}>
                                        <Button
                                            fullWidth
                                            color="primary"
                                            variant="outlined"
                                            onClick={sendLocation}
                                            disabled={!validPhoneNumber || sending}
                                        >
                                            ارسال موقعیت
                                        </Button>
                                    </Grid>
                                    <Grid item xs={6} sm={3}>
                                        <Button
                                            fullWidth
                                            color="primary"
                                            variant="contained"
                                            onClick={copyLocation}
                                        >
                                            کپی موقعیت
                                        </Button>
                                    </Grid>
                                </>
                            )}
                        </Grid>
                    </Paper>
                )}
                {
                    installment &&


                    <Paper className="mt-2 mb-4 p-2" variant="outlined">
                        <Typography component="h3" variant="h6">
                            اطلاعات قسط
                        </Typography>
                        <Divider className="my-2" />
                        <Grid container spacing={2}>
                            <Grid item sm={6}>
                                <Typography component="span">عنوان قسط: </Typography>
                                <Typography component="span">{installment.title}</Typography>
                            </Grid>
                            <Grid item sm={6}>
                                <Typography component="span">تعداد قسط: </Typography>
                                <Typography component="span">{installment.count}</Typography>
                            </Grid>

                            <Grid item sm={12}>
                                <Divider className="my-2" />
                            </Grid>

                            {
                                installmentForm.map((item, index) => (
                                    <Grid item sm={12}>
                                        <Typography component="span" style={{ width: 'bold' }}>{item.title}: </Typography>
                                        <Typography component="span">{answersOfInstallment?.[item.id]}</Typography>
                                    </Grid>
                                ))
                            }
                        </Grid>
                    </Paper>
                }

                <Paper className="mt-2 mb-4 p-2" variant="outlined">
                    <div className="d-flex space-between align-center mb-2">
                        <Typography component="h3" variant="h6">
                            سفارش {trackingCode}
                        </Typography>
                        <div className="d-flex align-center">
                            <Button
                                size="small"
                                color="primary"
                                variant="outlined"
                                startIcon={<Print />}
                                onClick={printInvoice}
                                disabled={!info}
                                style={{ marginLeft: 8 }}
                            >
                                چاپ فاکتور
                            </Button>
                            <Typography component="span">{dateFormat(createDate)}</Typography>
                        </div>
                    </div>
                    <Grid container className="mb-2">
                        <Grid item>
                            <Typography>نوع خرید: {info?.orderType === "inPerson" ? "خرید حضوری" : "خرید آنلاین"}</Typography>
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid item>
                            <Typography>نوع ارسال: {info?.deliveryMethod?.name}</Typography>
                        </Grid>
                    </Grid>
                    <Divider className="my-2" />

                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>#</TableCell>
                                <TableCell></TableCell>
                                <TableCell>نوع</TableCell>
                                <TableCell>برند</TableCell>
                                <TableCell>نام</TableCell>
                                <TableCell>رنگ</TableCell>
                                <TableCell>سایز</TableCell>
                                <TableCell>قیمت</TableCell>
                                <TableCell>تخفیف/بیمه</TableCell>
                                <TableCell align="center">تعداد</TableCell>
                                <TableCell align="right">قیمت کل</TableCell>
                                <TableCell></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {info?.items?.length ? info.items.map((item, idx) => (
                                <Fragment key={item.id}>
                                    <TableRow>
                                        <TableCell rowSpan={item.lens ? 2 : 1}>{idx + 1}</TableCell>
                                        <TableCell style={{ cursor: 'pointer' }} onClick={() => setShowFullImg(item.frontImage)}>
                                            <img src={item.frontImage} />
                                        </TableCell>
                                        <TableCell>{item.category}</TableCell>
                                        <TableCell>{item.brand}</TableCell>
                                        <TableCell>{item.name}</TableCell>
                                        <TableCell>{item.color}</TableCell>
                                        <TableCell>{item.size || "-"}</TableCell>
                                        <TableCell>{currencyFormat(item.price)}</TableCell>
                                        <TableCell>
                                            {item.discount ? currencyFormat(item.discount) : "-"}
                                        </TableCell>
                                        <TableCell align="center" rowSpan={item.lens ? 2 : 1}>
                                            {item.count}
                                        </TableCell>
                                        <TableCell align="right" rowSpan={item.lens ? 2 : 1}>
                                            {currencyFormat(
                                                (item.price -
                                                    item.discount +
                                                    (item.lens
                                                        ? item.lens.price - item.lens.insuranceContribution
                                                        : 0)) *
                                                item.count
                                            )}
                                        </TableCell>
                                        <TableCell>
                                            {downloadingWarrantyItemId === item.id ? (
                                                <CircularProgress size={24} />
                                            ) : (
                                                <CloudDownload
                                                    style={{ cursor: "pointer" }}
                                                    onClick={() => generateAndDownloadWaranry(item)}
                                                />
                                            )}
                                        </TableCell>
                                    </TableRow>
                                    {item.lens && (
                                        <TableRow>
                                            <TableCell>
                                                <div style={{ display: "flex" }}>
                                                    عدسی
                                                    <div style={{ cursor: "pointer" }} onClick={() => openLensModal(item.id)}>
                                                        <InfoOutlined />
                                                    </div>
                                                </div>
                                            </TableCell>
                                            <TableCell colSpan={1} />
                                            <TableCell colSpan={3}>{item.lens.name}</TableCell>
                                            <TableCell>{currencyFormat(item.lens.price)}</TableCell>
                                            <TableCell>
                                                {item.lens.insuranceContribution
                                                    ? currencyFormat(item.lens.insuranceContribution)
                                                    : "-"}
                                            </TableCell>
                                            {/* <TableCell colSpan={2} /> */}
                                        </TableRow>
                                    )}
                                </Fragment>
                            )) : (
                                <TableRow>
                                    <TableCell colSpan={12} align="center">
                                        کالایی برای این سفارش ثبت نشده است.
                                    </TableCell>
                                </TableRow>
                            )}
                            <TableRow>
                                <TableCell colSpan={7} className="border-none" />
                                <TableCell colSpan={1} style={{ fontWeight: 700 }}>
                                    جمع کل
                                </TableCell>
                                <TableCell
                                    colSpan={2}
                                    align="right"
                                    style={{ fontWeight: 700 }}
                                >
                                    {currencyFormat(totalAmount)}
                                </TableCell>
                            </TableRow>
                            {Boolean(totalDiscount) && (
                                <TableRow>
                                    <TableCell className="border-none" colSpan={7} />
                                    <TableCell colSpan={1} style={{ fontWeight: 700 }}>
                                        تخفیف
                                    </TableCell>
                                    <TableCell
                                        colSpan={2}
                                        align="right"
                                        style={{ fontWeight: 700 }}
                                    >
                                        {currencyFormat(totalDiscount)}
                                    </TableCell>
                                </TableRow>
                            )}
                            {Boolean(totalInsurance) && (
                                <TableRow>
                                    <TableCell colSpan={7} className="border-none" />
                                    <TableCell colSpan={1} style={{ fontWeight: 700 }}>
                                        سهم بیمه
                                    </TableCell>
                                    <TableCell
                                        colSpan={2}
                                        align="right"
                                        style={{ fontWeight: 700 }}
                                    >
                                        {currencyFormat(totalInsurance)}
                                    </TableCell>
                                </TableRow>
                            )}
                            <TableRow>
                                <TableCell className="border-none" colSpan={7} />
                                <TableCell
                                    className="border-none"
                                    colSpan={1}
                                    style={{ fontWeight: 700 }}
                                >
                                    مبلغ قابل پرداخت
                                </TableCell>
                                <TableCell
                                    className="border-none"
                                    colSpan={2}
                                    align="right"
                                    style={{ fontWeight: 700 }}
                                >
                                    {currencyFormat(payableAmount)}
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </Paper>

                <SnappOrderActions
                    info={info}
                    onChanged={setInfo}
                    errorHandler={errorHandler}
                />

                {info?.orderType === "inPerson" && (
                    <Paper className="mt-2 mb-4 p-2" variant="outlined">
                        <Typography component="h3" variant="h6">
                            پرداخت‌های خرید حضوری
                        </Typography>
                        <Divider className="my-2" />
                        <Grid container spacing={2} className="mb-2">
                            <Grid item sm={4} xs={12}>
                                <Typography component="span">مبلغ کل: </Typography>
                                <Typography component="span">
                                    {currencyFormat(info?.totalAmount || totalAmount || 0)}
                                </Typography>
                            </Grid>
                            <Grid item sm={4} xs={12}>
                                <Typography component="span">پرداخت‌شده: </Typography>
                                <Typography component="span">
                                    {currencyFormat(info?.depositAmount || 0)}
                                </Typography>
                            </Grid>
                            <Grid item sm={4} xs={12}>
                                <Typography component="span">مانده: </Typography>
                                <Typography component="span">
                                    {currencyFormat(info?.remainingAmount || 0)}
                                </Typography>
                            </Grid>
                        </Grid>
                        <Table size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell>مبلغ</TableCell>
                                    <TableCell>روش پرداخت</TableCell>
                                    <TableCell>وضعیت</TableCell>
                                    <TableCell>تاریخ ثبت</TableCell>
                                    <TableCell>شماره تراکنش</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {info?.payments?.length ? (
                                    info.payments.map((payment) => (
                                        <TableRow key={payment.id}>
                                            <TableCell>{currencyFormat(payment.amount || 0)}</TableCell>
                                            <TableCell>
                                                {paymentMethodLabels[payment.method] || payment.method}
                                            </TableCell>
                                            <TableCell>
                                                {paymentStatusLabels[payment.status] || payment.status}
                                            </TableCell>
                                            <TableCell>{dateFormat(payment.createDate)}</TableCell>
                                            <TableCell className="en">
                                                {payment.transactionAuthority ||
                                                    payment.transaction?.authority ||
                                                    "-"}
                                            </TableCell>
                                        </TableRow>
                                    ))
                                ) : (
                                    <TableRow>
                                        <TableCell colSpan={5} align="center">
                                            پرداختی ثبت نشده است.
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </Paper>
                )}

                <FormBuilder
                    // schema={schema}
                    initialValues={initialValues}
                    handleSubmit={handleSubmit}
                    form={form}
                    formWrapper={(props) => <Grid container spacing={2} {...props} />}
                    actionComponent={({ isSubmitting }) => (
                        <DialogActions>
                            <Button onClick={close} color="primary" disabled={isSubmitting}>
                                لغو
                            </Button>
                            <Button
                                type="submit"
                                disabled={isSubmitting}
                                variant="contained"
                                color="primary"
                            >
                                تایید
                            </Button>
                        </DialogActions>
                    )}
                />
            </DialogContent>

            {
                lensDetail &&
                <Dialog
                    open={true}
                    fullWidth
                    maxWidth={"md"}
                    classes={{ paper: "matte-glass" }}
                >
                    <CoordinationFormModal
                        close={() => setLensDetail(null)}
                        extra={{
                            lenses: [{
                                ...lensDetail.lens,
                                id: lensDetail.userGlassLens.lensId
                            }]
                        }}
                        data={{
                            ...lensDetail.userGlassLens.coordination,
                            glass: { ...lensDetail },
                            items: [{ ...lensDetail, lensId: lensDetail.userGlassLens.lensId }]

                        }}
                    />
                </Dialog>
            }
        </>
        // </LoadingComponent>
    );
}
